export default __webpack_public_path__ + "static/media/logo-white.6b67f94e.png";